import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener, ElementRef, Input } from '@angular/core';
import { CompanyFormComponent } from '../company-form/company-form.component';
import { PlanMainService } from '.././plan/service/plan-main.service';
import { Router } from '../../../node_modules/@angular/router';
import { DataService } from '../services/data.service';
import { SettingDialogItemVisibleSetting } from './setting-dialog-item-visible-setting';

@Component({
  selector: 'app-setting-dialog',
  templateUrl: './setting-dialog.component.html',
  styleUrls: ['./setting-dialog.component.css']
})
export class SettingDialogComponent implements OnInit {
  public isChkMenuEnabledtoShow = [];
  public isMenuAutho;
  public menuAuthoMap: Map<string, number> = new Map();
  public checkLoginType: boolean = false;
  @ViewChild('form') companyform: CompanyFormComponent;
  @Output('close') close: any = new EventEmitter<any>();
  @Output('clickoutside') clickoutside: any = new EventEmitter<any>();
  @Output('toggleOsusumeSetting') toggleOsusumeSetting: any = new EventEmitter<boolean>();
  @Output('newInfo') newInfo: any = new EventEmitter<boolean>();

  //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
  // ボタン表示設定
  @Input('visibleSetting') visibleSetting:SettingDialogItemVisibleSetting;
  //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

  constructor(private element: ElementRef, private planmainService: PlanMainService, private router: Router, private _data: DataService) { }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.clickoutside.emit();
    }
  }

  ngOnInit() {

    this.planmainService.menuAutho.subscribe((res: any) => {
      if (res) {
        this.menuAuthoMap = <Map<string, number>>Object.values(res)
          .reduce(
            (acc: Map<string, number>, value: { menuId: string, enabled: number }) =>
              acc.set(value.menuId, value.enabled), new Map()
          );
      }
    });
    this.checkLoginType = this._data.loginTypeKbn == '2'? true : false;
  }

  Submit(value: string) {
    this.companyform.setFromAndSubmit(value);
  }
  onClose() {
    this.close.emit();
  }

  openOsusumeSetting() {
    // this.toggleOsusumeSetting.emit(true);
    this.router.navigate(['/osusume/setting']);
  }

  checkMenuAutho(menuName: string): boolean {
    if (this.menuAuthoMap.has(menuName)) {
      return this.menuAuthoMap.get(menuName) === 1;
    }
    return false;
  }

  onShowNews() {
    this.newInfo.emit(true);
    this.onClose();
  }
}



// WEBPACK FOOTER //
// ./src/app/setting-dialog/setting-dialog.component.ts